<div class="modal-header bg-primary text-white">
    <h5 class="modal-title">Kalan Yıllık İzinler</h5>
    <button type="button" class="close text-white" aria-label="Close" (click)="close()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body p-0">
    <div class="d-flex justify-content-between align-items-center m-1">
        <input type="text" class="form-control me-3" placeholder="departman..." [(ngModel)]="searchTerm"
            style="max-width: 300px;" />

        <div class="form-check form-check-inline">
            <input class="form-check-input" type="checkbox" id="isTotalCheckbox" [(ngModel)]="isTotal"
                (change)="onIsTotalChange()" />
            <label class="form-check-label" for="isTotalCheckbox">Toplam İzinleri Göster</label>
        </div>
    </div>
    <ngx-datatable class="bootstrap" [rows]="data" [columnMode]="'force'" [headerHeight]="50" [footerHeight]="50"
        [rowHeight]="'auto'" [scrollbarH]="true" [limit]="10">
        <ngx-datatable-column name="Sicil No" prop="registrationNumber"></ngx-datatable-column>
        <ngx-datatable-column name="Ad Soyad" prop="fullName"></ngx-datatable-column>
        <ngx-datatable-column name="Departman" prop="departmant"></ngx-datatable-column>
        <ngx-datatable-column name="Yıl" prop="year" [width]="80"></ngx-datatable-column>
        <ngx-datatable-column name="Hak Edilen" prop="entitledDays" [width]="120"></ngx-datatable-column>
        <ngx-datatable-column name="Kalan Gün" prop="remainingDays" [width]="120"></ngx-datatable-column>
    </ngx-datatable>
</div>

<div class="modal-footer">

    <button type="button" class="btn btn-info" (click)="exportExcel()" *ngIf="data?.length > 0">Exele Aktar</button>

    <button type="button" class="btn btn-success ml-1" (click)="loadData()">Görüntüle</button>
    <button type="button" class="btn btn-danger ml-1" (click)="close()">Kapat</button>

</div>